module.exports = __webpack_public_path__ + "img/app_in_white_en.134907b6.png";